import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=517aadec&scoped=true&"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517aadec",
  null
  
)

export default component.exports